
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { editMicroStoreInfo, getMicroStoreInfo } from '@/api/store'
import { Debounce } from '@/core/decorator'
import ConfirmClosePopup from './ConfirmClosePopup.vue'

@Component({
  name: 'NewCCXStore',
  components: {
    ConfirmClosePopup
  }
})
export default class NewCCXStore extends Vue {
  @Getter companyId!: string


  detailData: any = {
    openOnlineStore: 0,
    pickupStartTime: '',
    pickupEndTime: '',
    takeStartTime: '',
    takeEndTime: '',
    receiveMobile: ''
  }

  // 是否显示验证提示
  showValidationTip = false
  isShake = false

  errShakeClass = 'animate__animated animate__headShake'

  created() {
    // 获取店铺详情数据
    getMicroStoreInfo({ storeId: this.companyId }).then(res => {
      let storeData = res?.data || {}
      const { pickupStartTime, pickupEndTime, takeStartTime, takeEndTime } = storeData
      // 去掉时间字符串中的秒
      const formatTime = (time) => time?.replace(/:00$/, '') || ''
      storeData = {
        ...storeData,
        pickupStartTime: formatTime(pickupStartTime),
        pickupEndTime: formatTime(pickupEndTime),
        takeStartTime: formatTime(takeStartTime),
        takeEndTime: formatTime(takeEndTime),
        openOnlineStore: storeData.openOnlineStore === 1 ? true : false
      }
      this.detailData = storeData
      // 更新店铺信息
      this.$store.commit('SET_CCX_STORE', storeData)
    })
    // this.loadStoreConfig()
  }

  // 加载微店配置
  // async loadStoreConfig() {
  //   try {
  //     const res = await getMicroStoreInfo({ storeId: this.companyId })
  //     if (res.code === '000000' && res.data) {
  //       const data = res.data
  //       this.isStoreOpen = !!data.openOnlineStore
  //       this.storePhone = data.receiveMobile || ''
        
  //       if (data.openStartTime && data.openEndTime) {
  //         this.businessTime.startTime = data.openStartTime.substring(0, 5)
  //         this.businessTime.endTime = data.openEndTime.substring(0, 5)
  //       }
        
  //       if (data.takeStartTime && data.takeEndTime) {
  //         this.pickupTime.startTime = data.takeStartTime.substring(0, 5)
  //         this.pickupTime.endTime = data.takeEndTime.substring(0, 5)
  //       }
  //     }
  //   } catch (e) {
  //     console.error('获取微店配置失败', e)
  //     this.$toast.fail('获取配置失败')
  //   }
  // }


  // 开关变化
  async onSwitchChange(value: boolean) {
    if (value) {
      // 开通微店前先校验数据是否完整
      if (!this.detailData.pickupStartTime || !this.detailData.pickupEndTime || !this.detailData.takeStartTime || !this.detailData.takeEndTime || !this.detailData.receiveMobile) {
        this.showValidationTip = true
        this.isShake = true
        this.detailData.openOnlineStore = false
        setTimeout(() => {
          this.isShake = false
        }, 1000)
        return
      }
      
      // 数据完整，隐藏提示
      this.showValidationTip = false

      await this.updateStoreStatus(true)
    } else {
      // 关闭微店 - 显示自定义确认弹框
      (this.$refs.confirmClosePopup as ConfirmClosePopup).showPopup()
    }
  }

  // 处理关闭微店确认
  async handleCloseConfirm() {
    await this.updateStoreStatus(false)
    this.showValidationTip = false
  }

  // 处理取消关闭
  handleCloseCancel() {
    this.detailData.openOnlineStore = true
  }

  @Debounce(500)
  async updateStoreStatus(openOnlineStore: boolean) {
    try {
        const res = await editMicroStoreInfo({
            storeId: this.companyId,
            openOnlineStore: openOnlineStore
        })
        if (res.code === '000000') {
            this.$toast(openOnlineStore ? '已开通' : '已关闭')
        } else {
            this.$toast.fail(res.msg || '操作失败')
            // Revert status if failed
            this.detailData.openOnlineStore = !openOnlineStore
        }
    } catch (e) {
        console.error(e)
        this.$toast.fail('操作失败')
        this.detailData.openOnlineStore = !openOnlineStore
    }
  }

  // 选择时间,1营业时间，3提货时间
  selectTime(type) {
    this.$router.push({
      path: '/editBusinessTime',
      query: {
        takeStartTime: this.detailData.takeStartTime,
        takeEndTime: this.detailData.takeEndTime,
        pickupStartTime: this.detailData.pickupStartTime,
        pickupEndTime: this.detailData.pickupEndTime,
        pickerType: type
      }
    })
  }

  // 选择联系电话
  selectPhone() {
    this.$router.push({
      path: '/editPhone',
      query: {
        receiveMobile: this.detailData.receiveMobile
      }
    })
  }
}
